import {
  HttpErrorResponse,
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../../services/API/auth.service/auth.service';
import { catchError, finalize, switchMap } from 'rxjs/operators';
import { throwError, Observable } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { LoaderService } from '../../services/state-management/loader.service/loader.service';
import { LOCAL_STORAGE } from '../../models/constant/constants';
import { TokenService } from '../../services/state-management/token.service/token.service';

export const AuthInterceptor: HttpInterceptorFn = (
  req: HttpRequest<any>,
  next
) => {
  const authService = inject(AuthService);
  const tokenService = inject(TokenService);
  const loaderService = inject(LoaderService);
  const toastr = inject(ToastrService);
  
  const router = inject(Router);

  const authToken = tokenService.getToken();

  // Show loader when request starts
  if(!req.headers.get("no-loader")) {
    loaderService.requestCounter++;
    
    if(!loaderService.loadingSubject.value) {
      loaderService.showLoader();
    }
  }

  // Clone request to attach token if available
  let authReq = req;
  if (authToken && !req.url.includes("getAccessTokenFromRefreshToken") && !req.url.includes("photospicker")) {
    authReq = req.clone( { headers: req.headers.set('Authorization', `${authToken}`), });
  }

  return next(authReq).pipe(
    catchError((err: HttpErrorResponse) => {
      const errorMessage =
        err.error?.message || err.message || 'Something went wrong.';
                
        switch (err.status) {
          case 401:
            toastr.error(errorMessage);
            // authService.logout();
            // router.navigate(['/auth/login']);
            return throwError(() => err);
            break;

          case 403:
            if(!err.url?.includes("getAccessTokenFromRefreshToken")) {
              if(!tokenService.getRefreshToken()) {
                // toastr.error('Session expired. Please login again.');
                localStorage.clear();
                sessionStorage.clear();
                // authService.logout();
                router.navigate(['/auth/login']);
                location.reload();
                return throwError(() => new Error('Session expired.'));
              }
              return authService.getAccessTokenFromRefreshToken()
                .pipe(
                  switchMap((res) => {
                    tokenService.setToken(LOCAL_STORAGE.TOKEN, res.data);
                    const newAuthReq = req.clone({
                      headers: req.headers.set('Authorization', `${res.data}`),
                    });
                    return next(newAuthReq);
                  }),
                  catchError((err) => {
                    console.log(err,' err');
                    
                    // toastr.error('Session expired. Please login again.');
                    localStorage.clear();
                    sessionStorage.clear();
                    // authService.logout();
                    router.navigate(['/auth/login']);
                    location.reload();
                    return throwError(() => new Error('Session expired.'));
                  })
                )
              toastr.error(errorMessage);
              authService.logout();
              router.navigate(['/auth/login']);
              return throwError(() => err);
            }
            return throwError(() => err);
            break;


          case 400:
            toastr.error(errorMessage);
            // authService.logout();
            // router.navigate(['/auth/login']);
            return throwError(() => err);
            break;

          default:
            return throwError(() => err);
        }
    }),
    finalize(() => {

      // Hide loader when request completes or errors out
      if(!req.headers.get("no-loader")) {
        --loaderService.requestCounter;
      }
      if (loaderService.requestCounter === 0) {
        loaderService.hideLoader();
      }
    })
  );
};
